import { toastError } from '@components/Toast';

import { Types } from '@store/types';

import ApiClient from '@lib/apiClient';

export const fetchOrderDashboardHeadings = () => async (dispatch) => {
	await ApiClient.GET('getDeliverableMasterData')
		.then((response) => {
			dispatch({
				type: Types.STORE_ORDER_DASHBOARD_TABLE_HEADINGS,
				payload: response.data
			});
		})
		.catch((error) => {
			toastError(error.response.data.message);
		});
};
